const scrollStyles = {
  bottom: 30,
  right: 20
}

export { scrollStyles }